import {
  ERegionCode,
  ICoverageConfig,
  IAutoRegionConfig,
} from '../../../interfaces';
import defaultRegionConfig from '../defaultRegionConfig';
import * as regionConfigs from '../regions';

type TGetRegionCoveragesOptions = {
  filterByAppliesTo?: ICoverageConfig['appliesTo'];
};

export default function getRegionCoverages(
  regionCode: ERegionCode,
  opts?: TGetRegionCoveragesOptions
): ICoverageConfig[] {
  const regionConfig =
    (regionConfigs as Record<ERegionCode, IAutoRegionConfig>)?.[regionCode] ||
    defaultRegionConfig;

  if (opts?.filterByAppliesTo) {
    return regionConfig.coverages.filter(
      (coverage) => coverage.appliesTo === opts.filterByAppliesTo
    );
  }

  return regionConfig.coverages;
}
